module.exports = {
  install: function (Vue) {
    Vue.prototype.$mousetrap = require('mousetrap')
  }
};
